export default "__VITE_ASSET__BN9_Iij9__"